module.exports = __webpack_public_path__ + "static/media/card-content-video.d18ab0ff.svg";